import { ReasonForBlockedDate } from 'src/screens/ManualOrder/types';

const { DatePassed, Unknown, DateOnBlockedList } = ReasonForBlockedDate;

/** Reasons a day stays blocked even when a shift is chosen */
export const BLOCKED_FOR_RE_ENABLING_REASONS: ReasonForBlockedDate[] = [DatePassed, Unknown, DateOnBlockedList];

/**
 * Whether a day cannot be ordered — the rule of the days grid, shared with the date range.
 * Kept free of store imports so it can be unit-tested (hooks/common.ts pulls the store in).
 * @param reason - why the day is blocked for the selected passengers and shift, if it is
 * @param isShiftSelected - no day can be chosen before a shift is
 * @param isReplacingOrderOnDayWithMaxOrders - editing an order on a day that already has the maximum
 */
export const isDayDisabledForOrder = (
    reason: ReasonForBlockedDate | null | undefined,
    isShiftSelected: boolean,
    isReplacingOrderOnDayWithMaxOrders: boolean
): boolean => {
    if (!isShiftSelected) return true;
    if (!reason) return false;

    if (BLOCKED_FOR_RE_ENABLING_REASONS.includes(reason)) return true;

    if (isReplacingOrderOnDayWithMaxOrders) {
        return false;
    }

    return true;
};
